import React from 'react';
import PropTypes from 'prop-types';

import { useDxSectionStyles } from './dxsection';
import AuditResolutionDialog from './auditresolutiondialog';

const AuditReasons = ({
  isAudit,
  isReview,
  encounterAuditReasons,
  isAuditResolutionDialogVisible,
  openAuditResolutionDialog,
  closeAuditResolutionDialog,
  resolveAuditReason,
  selectedAuditReasonId,
  selectedAuditReasonIsResolvedValue,
  auditResolutionOptions,
  selectAuditResolutionOption,
  selectedAuditResolutionOptionId,
  hydrateEncounterAuditReasons
}) => {
  const classes = useDxSectionStyles();
  const auditReasonClass = isAudit || isReview
    ? classes.auditReasonsContainer
    : classes.hiddenContainer;

  return (
    <div className={auditReasonClass}>
      <h5><u>Audit Reasons</u></h5>
      {
        encounterAuditReasons.map(x => {
          return (
            <div
              key={x.encounterAuditReasonId}
              className={classes.auditReasonItem}
            >
              <label>
                <input
                disabled={isReview}
                checked={x.isResolved}
                type='checkbox'
                onChange={() => {
                  openAuditResolutionDialog(
                    x.encounterAuditReasonId,
                    x.isResolved
                  )
                }}
                />
                <span>{x.reasonType} - {x.description}</span>
              </label>
            </div>);
        })
      }

      <AuditResolutionDialog
        isOpen={isAuditResolutionDialogVisible}
        closeAuditResolutionDialog={closeAuditResolutionDialog}
        resolveAuditReason={resolveAuditReason}
        selectedAuditReasonId={selectedAuditReasonId}
        selectedAuditReasonIsResolvedValue={selectedAuditReasonIsResolvedValue}
        auditResolutionOptions={auditResolutionOptions}
        selectAuditResolutionOption={selectAuditResolutionOption}
        selectedAuditResolutionOptionId={selectedAuditResolutionOptionId}
        hydrateEncounterAuditReasons={hydrateEncounterAuditReasons}
      />
    </div>
  );
};

AuditReasons.propTypes = {
  isAudit: PropTypes.bool.isRequired,
  isReview: PropTypes.bool.isRequired,
  encounterAuditReasons: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string.isRequired,
    encounterAuditReasonId: PropTypes.number.isRequired,
    encounterId: PropTypes.number.isRequired,
    isResolved: PropTypes.bool.isRequired,
    reasonType: PropTypes.string.isRequired
  })).isRequired,
  isAuditResolutionDialogVisible: PropTypes.bool.isRequired,
  resolveAuditReason: PropTypes.func.isRequired,
  openAuditResolutionDialog: PropTypes.func.isRequired,
  closeAuditResolutionDialog: PropTypes.func.isRequired,
  selectedAuditReasonId: PropTypes.number.isRequired,
  selectedAuditReasonIsResolvedValue: PropTypes.bool.isRequired,
  auditResolutionOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  selectAuditResolutionOption: PropTypes.func.isRequired,
  selectedAuditResolutionOptionId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  hydrateEncounterAuditReasons: PropTypes.func.isRequired
};

export default AuditReasons;
